import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles({
  icon: {
    width: '1rem',
    height: '1rem',
  },
});

const KeyboardRightIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 10 16" className={styles.icon} fill="none">
      <path
        d="M0 14.12L6.18084 8L0 1.88L1.90283 0L10 8L1.90283 16L0 14.12Z"
        fill="black"
      />
    </SvgIcon>
  );
};

export default memo(KeyboardRightIcon);
